import React, { createContext, useContext, useState } from 'react';
import axios from 'axios';
import route from 'ziggy-js';

type ContextProps = {
  previewing: boolean;
  setPreviewing: (previewing: boolean) => void;
  packageErrors: object[];
  getPackageErrors: (packageId: string) => void;
};

export type LogError = {
  file_name: string;
  line: number;
  message: string;
  type: number;
};

export const PlaygroundContext = createContext<ContextProps | undefined>(
  undefined
);

export const usePlayground = () => {
  const context = useContext(PlaygroundContext);
  if (!context) {
    throw new Error(`usePlayground must be used within an PlaygroundProvider`);
  }
  return context;
};

export default function PlaygroundProvider({
  file,
  children,
}: {
  file: App.Data.FileData;
  children: React.ReactNode;
}) {
  const [previewing, setPreviewing] = useState(false);
  const [packageErrors, setPackageErrors] = useState([]);

  function getPackageErrors(packageId: string) {
    axios
      .get(route('api.packages.get-errors', packageId))
      .then(response => {
        setPackageErrors(response.data);
      });
  }

  return (
    <PlaygroundContext.Provider
      value={{
        previewing,
        setPreviewing,
        packageErrors,
        getPackageErrors,
      }}
    >
      {children}
    </PlaygroundContext.Provider>
  );
}
